import { FlapExpression } from '@/common/components/PromoBar/Counter/FlapExpression';

import styles from './Counter.module.scss';

interface CounterProps {
  days: string;
  hours: string;
  minutes: string;
  seconds: string;
}

export const Counter = ({ days, hours, minutes, seconds }: CounterProps) => (
  <div className={styles.counterWrapper} data-testid="promo-bar-counter">
    <FlapExpression expression={days} label="Days" />
    :
    <FlapExpression expression={hours} label="Hours" />
    :
    <FlapExpression expression={minutes} label="Minutes" />
    :
    <FlapExpression expression={seconds} label="Seconds" />
  </div>
);
